import { Alert, Box } from '@mui/joy';
import { Warning } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Color, Size, Variant } from 'theme/enums';

interface IProps {
  initialValues: {
    shipmentTypeId: number;
    corporateLocationId: number;
  };
  currentValues: {
    shipmentTypeId: number;
    corporateLocationId: number;
  };
}

export const ShippingFieldsChangeWarning = ({ initialValues, currentValues }: IProps) => {
  const { t } = useTranslation();

  const hasFieldChanged = (field: 'shipmentTypeId' | 'corporateLocationId') => {
    return (
      !!initialValues[field] &&
      !!currentValues[field] &&
      initialValues[field] !== currentValues[field]
    );
  };

  const hasChanged = hasFieldChanged('shipmentTypeId') || hasFieldChanged('corporateLocationId');

  if (!hasChanged) {
    return null;
  }

  return (
    <Alert
      startDecorator={<Warning style={{ width: 24, height: 24 }} />}
      variant={Variant.SOFT}
      color={Color.WARNING}
      size={Size.LG}
      sx={{
        alignItems: 'flex-start',
        width: '100%',

        '& .MuiAlert-startDecorator': {
          marginTop: '2px',
        },
      }}
    >
      <Box sx={{ fontSize: 14 }}>{t('messageShippingFieldsChangeWarning')}</Box>
    </Alert>
  );
};
